import { UtilityCyclesPage } from '@/components/billing/utility-cycles-page'

export function OperationsBillingUtilityCycles() {
  return <UtilityCyclesPage basePath="/operations/billing" />
}
